<template>
  <div class="container mt-3">
    <div class="row mb-3">
      <div class="col-8">
        <h3>Calendar <small class="text-muted ml-2">Events & Fixtures</small></h3>
        <b-form-checkbox id="checkbox1" v-model="eventsOn" :value="true" :unchecked-value="false">Display events</b-form-checkbox>
      </div>
      <div class="col-4 text-right">
        <router-link :to="{ name: 'EventAdd' }">
          <button type="button" class="btn btn-primary">Create Event</button>
        </router-link>
      </div>
    </div>
    <calendar-view
      v-if="events"
      @click-event="eventClicked"
      :show-date="showDate"
      :events="events"
      :startingDayOfWeek="1"
      :displayPeriodCount="1"
      displayPeriodUom="month"
      class="theme-default">
      <calendar-view-header
        slot="header"
        slot-scope="t"
        :header-props="t.headerProps"
        @input="setShowDate" />
    </calendar-view>
    <Loading v-else/>
  </div>
</template>
<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import { eventService } from './../../services/event'
import { fixtureService } from './../../services/fixture'
require('vue-simple-calendar/static/css/default.css')

export default {
  name: 'Calendar',
  components: { CalendarView, CalendarViewHeader },
  data () {
    return {
      showDate: new Date(),
      events: null,
      apiEvents: null,
      apiFixtures: null,
      eventsOn: true
    }
  },
  mounted () {
    this.events = []
    eventService.getAll().then(result => {
      this.apiEvents = result.data.events
      for (let event of result.data.events) {
        let formattedEvent = {
          startDate: new Date(event.date_start),
          endDate: event.date_end ? new Date(event.date_end) : null,
          title: `${event.competition.sport.name} - ${event.competition.name} - ${event.name}`,
          id: event._id,
          classes: 'click event',
          type: 'event'
        }
        this.events.push(formattedEvent)
      }
    })
    fixtureService.getAll().then(result => {
      this.apiFixtures = result.data.fixtures
      for (let fixture of result.data.fixtures) {
        let formattedEvent = {
          startDate: new Date(fixture.date_start),
          title: fixture.name,
          id: fixture._id,
          classes: 'click fixture',
          type: 'fixture'
        }
        this.events.push(formattedEvent)
      }
    })
  },
  methods: {
    setShowDate (d) {
      this.showDate = d
    },
    eventClicked (event) {
      if (event.originalEvent.type === 'event') {
        this.$router.push({ name: 'Event', params: { id: event.id } })
      }
      if (event.originalEvent.type === 'fixture') {
        this.$router.push({ name: 'Fixture', params: { id: event.id } })
      }
    }
  },
  watch: {
    eventsOn (bool) {
      this.events = []
      if (bool) {
        for (let event of this.apiEvents) {
          let formattedEvent = {
            startDate: new Date(event.date_start),
            endDate: event.date_end ? new Date(event.date_end) : null,
            title: `${event.competition.sport.name} - ${event.competition.name} - ${event.name}`,
            id: event._id,
            classes: 'click event',
            type: 'event'
          }
          this.events.push(formattedEvent)
        }
      }
      for (let fixture of this.apiFixtures) {
        let formattedEvent = {
          startDate: new Date(fixture.date_start),
          title: fixture.name,
          id: fixture._id,
          classes: 'click fixture',
          type: 'fixture'
        }
        this.events.push(formattedEvent)
      }
    }
  }
}
</script>
<style lang="scss">
div.theme-default{
  height: 80vh;
}
.fixture{
  background: rgb(245, 219, 195) !important;
  border-color: rgb(201, 164, 129) !important;
}
.click{
  cursor:pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Calendar/Calendar.vue